import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CommonDataSource } from '@app/workflow-common/services/CommonDataSource';
import { SharedModalService } from '@app/shared-modal/service/shared-modal.service';

@Component({
    selector: 'app-cs-search-bar',
    templateUrl: './cs-search-bar.component.html',
    styleUrls: ['cs-search-bar.component.scss']
})
export class CsSearchBarComponent implements OnInit {

    @Input() placeHolder = 'Search';
    @Input() searchText = ''; // Note: Use this for clear the searched text from parent component
    @Input() isHideClearBtn = false;
    @Input() showUserListDropDown = false;
    @Input() showTagListDropDown = false;
    usersList: any[] = [];
    filteredUsers: string[] = [];
    tagsList: any[] = [];
    filteredTags: any[] = [];
    private tagsLoaded: boolean = false;
    showSearchDropdown: boolean = false;
    showTagSearchDropdown: boolean = false;
    timeDelay: any = "";
    searchInputValue: string = '';

    @Output() onItemSearch = new EventEmitter<any>();


    constructor(private sharedModalService: SharedModalService) {
    }

    async ngOnInit() {
        // await CommonDataSource.getUserData();
        // if (CommonDataSource.userData['userRecords']) {
        //     this.usersList = CommonDataSource.userData['userRecords'];
        // }
        await CommonDataSource.getUserData();
        if (CommonDataSource.userData['userRecords']) {
            this.usersList = CommonDataSource.userData['userRecords'].map(user => ({
                ...user, selected: false
            }));
        }
    }

    searchItem(e) {
        this.searchText = e;
        if (this.showUserListDropDown) {
            const data = {
                searchText: this.searchText,
            };
            this.onItemSearch.emit(data);
        } else {
            this.onItemSearch.emit(this.searchText);
        }
    }

    onSearch(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
        const text = event.target.value;
        const atIndex = this.showUserListDropDown ? text.lastIndexOf('@') : -1;
        const hashIndex = this.showTagListDropDown ? text.lastIndexOf('#') : -1;

        if (hashIndex > atIndex && hashIndex !== -1) {
            this.showSearchDropdown = false;
            const match = text.match(/#(\w*)/);
            this.filterTags(match ? match[1] : '');
        } else if (atIndex !== -1 && atIndex !== text.length - 1) {
            this.showTagSearchDropdown = false;
            const regex = /@(\w+)/;
            const match = text.match(regex);
            if (match) {
                const searchText = match[1];
                this.filteredUsers = this.usersList.filter((user) =>
                    user.name.toLowerCase().includes(searchText.toLowerCase()) && (!user.hasOwnProperty('selected') || !user.selected)
                );
                this.showSearchDropdown = !!searchText && this.filteredUsers.length > 0;
            } else {
                this.showSearchDropdown = false;
            }
        }
        else if (atIndex === -1 && hashIndex === -1) {
            this.showSearchDropdown = false;
            this.showTagSearchDropdown = false;
            let _self = this;
            clearTimeout(this.timeDelay);
            this.timeDelay = setTimeout(() => {
                _self.getSearchedValue();
            }, 1000);
        }
    }

    private filterTags(term: string) {
        const applyFilter = () => {
            this.filteredTags = this.tagsList.filter((tag) =>
                tag.description.toLowerCase().includes(term.toLowerCase()) && !tag.selected
            );
            this.showTagSearchDropdown = this.filteredTags.length > 0;
        };
        if (!this.tagsLoaded) {
            this.tagsLoaded = true;
            this.sharedModalService.getHashTagsList().subscribe((response: any) => {
                this.tagsList = (response.hashtags || []).map(tag => ({...tag, selected: false}));
                applyFilter();
            });
        } else {
            applyFilter();
        }
    }

    removeUser(user) {
        user.selected = false;
        this.getSearchedValue();
    }

    removeTag(tag) {
        tag.selected = false;
        this.getSearchedValue();
    }

    searchLeave() {
        setTimeout(() => {
            this.showSearchDropdown = false;
            this.showTagSearchDropdown = false;
            if (this.searchInputValue) {
                this.searchInputValue = this.searchInputValue.replace(/@(\w*)/, '').replace(/#(\w*)/, '');
            }
        }, 300);
    }

    getSearchedValue() {
        const data: any = {
            searchText: this.searchInputValue,
        };
        if (this.showUserListDropDown) {
            data.userId = this.getSelectedUserId();
        }
        if (this.showTagListDropDown) {
            data.tagIds = this.getSelectedTagIds();
        }
        this.onItemSearch.emit(data);
    }

    getSelectedUserId() {
        if (!this.usersList || !Array.isArray(this.usersList)) {
            return '';
        }

        let users = this.usersList
            .filter(user => user.selected)
            .map(user => user.id);

        return users.join(',');
    }

    getSelectedTagIds() {
        if (!this.tagsList || !Array.isArray(this.tagsList)) {
            return '';
        }

        return this.tagsList
            .filter(tag => tag.selected)
            .map(tag => tag.id)
            .join(',');
    }


    selectUser(user) {
        user.selected = true;
        this.showSearchDropdown = false;
        setTimeout(() => {
            this.getSearchedValue();
        }, 350);
    }

    selectTag(tag) {
        tag.selected = true;
        this.showTagSearchDropdown = false;
        this.searchInputValue = this.searchInputValue.replace(/#(\w*)$/, '');
        setTimeout(() => {
            this.getSearchedValue();
        }, 350);
    }

    clearSearch() {
        this.searchText = '';
        this.onItemSearch.emit(this.searchText);
    }

    clearSearchValue() {
        if (this.showUserListDropDown || this.showTagListDropDown) {
            this.searchInputValue = '';
            this.usersList = this.usersList.map(user => ({...user, selected: false}));
            this.tagsList = this.tagsList.map(tag => ({...tag, selected: false}));
            this.getSearchedValue();
        } else {
            this.searchInputValue = '';
        }
    }

    resetInput() {
        this.usersList = this.usersList.map(user => ({...user, selected: false}));
        this.tagsList = this.tagsList.map(tag => ({...tag, selected: false}));
        this.searchInputValue = '';
    }


}
